export default __webpack_public_path__ + "static/media/ve_2.7e6ea41f.mp3";